import React from "react";
import { Popover } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { setQuestionType } from "../../../redux/local/local.actions";
import { ReactComponent as Mc } from "../../../assets/img/mc.svg";
import "./question-popover.style.css";

const QuestionsPopover = () => {
   const dispatch = useDispatch();

   const handleClick = (questionType) => () => {
      dispatch(setQuestionType(questionType));
   };

   return (
      <Popover id="questions-popover">
         <Popover.Content>
            <Link
               to="/create-question"
               className="d-flex align-items-center question-popup-link"
            >
               <span>
                  <Mc />
               </span>
               <Popover.Title
                  className="pointerType"
                  onClick={handleClick("mc")}
               >
                  Multiple Choice
               </Popover.Title>
            </Link>
         </Popover.Content>
      </Popover>
   );
};

export default QuestionsPopover;
